import React from 'react';
import Slider from 'react-slick';
import './BrandShowcase.css';

import UnileverLogo from '../../assets/TempWorkLogos/UnileverLogo.webp'
import CloroxLogo from '../../assets/TempWorkLogos/CloroxLogo.webp'
import NestleLogo from '../../assets/TempWorkLogos/NestleLogo.png'
import KSMLogo from '../../assets/TempWorkLogos/KSMLogoNoBG.webp'

const brands = [
  {
    name: 'Unilever',
    image: UnileverLogo,
    url: 'https://www.example.com/brand-a'
  },
  {
    name: 'Clorox',
    image: CloroxLogo,
    url: 'https://www.example.com/brand-b'
  },
  {
    name: 'Nestle',
    image: NestleLogo,
    url: 'https://www.example.com/brand-c'
  },
  {
    name: 'KSM-66',
    image: KSMLogo,
    url: 'https://www.example.com/brand-a'
  },
  {
    name: 'Clorox',
    image: CloroxLogo,
    url: 'https://www.example.com/brand-b'
  },
  {
    name: 'Nestle',
    image: NestleLogo,
    url: 'https://www.example.com/brand-c'
  },
  {
    name: 'Unilever',
    image: UnileverLogo,
    url: 'https://www.example.com/brand-a'
  },
  {
    name: 'Clorox',
    image: CloroxLogo,
    url: 'https://www.example.com/brand-b'
  },
  {
    name: 'Nestle',
    image: NestleLogo,
    url: 'https://www.example.com/brand-c'
  },
  {
    name: 'Unilever',
    image: UnileverLogo,
    url: 'https://www.example.com/brand-a'
  },
  {
    name: 'Clorox',
    image: CloroxLogo,
    url: 'https://www.example.com/brand-b'
  },
  {
    name: 'Nestle',
    image: NestleLogo,
    url: 'https://www.example.com/brand-c'
  }
];

const BrandShowcase = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 5,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    centerMode: true,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="brand-showcase">
      <div className="content">
        <h2 className="title">Our Trusted Brands</h2>
        <Slider {...settings} className="carousel">
          {brands.map((brand, index) => (
            <div key={index} className="slide">
              <a href={brand.url} target="_blank" rel="noopener noreferrer">
                <img
                  src={brand.image}
                  alt={`Brand ${index + 1}`}
                  className="brand-image"
                  width="140"    // Added width attribute
                  height="90"    // Added height attribute
                />
              </a>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default BrandShowcase;

// Brands in mind, Nestle, Unilever, KSM-66? Either thinking about showing cutomers or exclusive deal companies